import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Accordion } from '@zoopla-eng/zds-components/accordion';
import { Box } from '@zoopla-eng/zds-components/box';
import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import Script from 'next/script';
import { FC, ReactElement, useState } from 'react';
import { CONTENTFUL_RICH_TEXT_OPTIONS } from '../../../ContentfulRenderOptions';
import { constructGoogleFaqSchema } from '../../../functions/constructGoogleFaqSchema';
import { faqDescriptionStyle, faqWrapperStyle } from './FAQ.styles.css';
import { FaqCollection } from './FAQ.types';

export const FAQComponent: FC<FaqCollection> = ({
    description,
    title,
    faqs = [],
    injectSchema = false
}) => {
    const [value, updateValue] = useState<string[]>([]);
    const list = Array.isArray(faqs) ? faqs : [faqs];

    const panels =
        list.reduce<
            { label: string; value: string; component: ReactElement }[]
        >((ps, faq, index) => {
            if (!faq) {
                return ps;
            }

            const component = documentToReactComponents(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                faq.answer,
                CONTENTFUL_RICH_TEXT_OPTIONS
            );

            if (!component) {
                return ps;
            }

            return [
                ...ps,
                {
                    label: faq.question,
                    value: `${index + 1}`,
                    component: (
                        <Box
                            display="flex"
                            flexDirection="column"
                            rowGap="S400"
                            pb="S400"
                        >
                            {component}
                        </Box>
                    )
                }
            ];
        }, []) ?? [];

    return (
        <>
            {injectSchema && (
                <Script type="application/ld+json" id="faqSchema">
                    {constructGoogleFaqSchema(list)}
                </Script>
            )}
            <div className={`${faqWrapperStyle} FAQ`}>
                {title && (
                    <Box pb="S300">
                        <PageSubtitleShort>{title}</PageSubtitleShort>
                    </Box>
                )}
                {description && (
                    <p className={`${faqDescriptionStyle} ${fontGroups.ladle}`}>
                        {description}
                    </p>
                )}
                <Accordion
                    value={value}
                    onValueChange={updateValue}
                    panels={panels}
                />
            </div>
        </>
    );
};
